import {
  OLD_SUPPORT_ACCOUNT_PREFIX,
  SUPPORT_ACCOUNT_POSTFIX,
} from '../../config/user';
import { withAPIAccount } from '../../lib/http/api';
import { parsedResponse } from '../../lib/http/http';
import {
  AccountType,
  IAPIresponse,
  ICreateGroupBody,
  IDeleteRoleBody,
  IRBACUserGroup,
} from '../../model';
import { PERMISSION_PREFIX } from '../config';

// 获取用户组列表
export const getUserGroupsList = (studioId: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const supportUserGroupPrefix = 'supportAccReq_userGroup';
      const url = `${PERMISSION_PREFIX}/user-group?studioID=${studioId}`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<ReadonlyArray<IRBACUserGroup>>(
        response,
        'data'
      );
      return res
        .filter((item) => !item.groupName.startsWith(supportUserGroupPrefix))
        .map((groupData) => {
          return {
            ...groupData,
            members: groupData.members?.filter(
              (member) =>
                !member.startsWith(OLD_SUPPORT_ACCOUNT_PREFIX) &&
                !member.endsWith(SUPPORT_ACCOUNT_POSTFIX)
            ),
          };
        });
    } catch (error) {
      console.log(error);
      return null;
    }
  });

// 删除用户组
export const deleteUserGroups = (groupID: number, body: IDeleteRoleBody) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${PERMISSION_PREFIX}/user-group/${groupID}`;
      const response = await api.commonRequest('DELETE', url, body);
      const res = await parsedResponse<IAPIresponse>(response, 'data');
      return res;
    } catch (error) {
      console.log(error);
      return null;
    }
  });

// 新建用户组
export const createUserGroups = (body: ICreateGroupBody) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${PERMISSION_PREFIX}/user-group`;
      const response = await api.commonRequest('POST', url, body);
      const res = await parsedResponse<number>(response, 'all');
      return res;
    } catch (error: any) {
      console.log(error);
      return error?.apiError;
    }
  });

// 编辑用户组
export const editUserGroups = (groupID: number, body: ICreateGroupBody) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${PERMISSION_PREFIX}/user-group/${groupID}`;
      const response = await api.commonRequest('PUT', url, body);
      const res = await parsedResponse<IAPIresponse>(response, 'all');
      return res;
    } catch (error: any) {
      console.log(error);
      return error?.apiError;
    }
  });
